const utils = {
    getChildrenIds: (node, addNodeId) => {
        let _childrenIds = addNodeId ? [node.jsonKey.name] : []
        for (const child of node.children) {
            _childrenIds = [..._childrenIds, child.jsonKey.name]
            if (child.hasChild) {
                _childrenIds = [..._childrenIds, ...utils.getChildrenIds(child)]
            }
        }
        return _childrenIds
    }
}

export default utils
